import { HubsAPI } from '@RestApi/api'
import { HubResponse, OrgsResponse, SessionResponse, UsersResponse } from '@RestApi/client'
import { atom, selector, useRecoilCallback, useSetRecoilState } from 'recoil'
import { isRTL } from 'src/common/rtl/rtlTransform'

// Quick copy-paste:
// import {sessionAtom, hubAtom, alertsAtom, currentPostDetailAtom, orgadminOrgsAtom, orgadminUsersAtom, restApiAtom, rpcApiAtom} from '@Modules/hubs/atoms'

export const restApiAtom = atom<any>({ key: 'restApi', default: null })
export const rpcApiAtom = atom<HubsAPI>({
  key: 'rpcApi',
  // @ts-ignore
  default: undefined,
})

export const cloudinaryUrlAtom = atom<string>({
  key: 'cloudinaryUrl',
  default: 'https://qa-assets.visioncritical.net/image',
})

export const sessionAtom = atom<SessionResponse>({
  key: 'session',
  default: { status: 420, vctraceid: '' },
})
export const hubAtom = atom<HubResponse>({ key: 'hub', default: { status: 420, vctraceid: '' } })
export const hubFonts = atom<Array<string>>({ key: 'hubfonts', default: [] })

export const alertsAtom = atom<AlertWithId[]>({ key: 'alerts', default: [] })

export const currentPostDetailAtom = atom<any>({ key: 'currentPostDetail', default: null })

export const orgadminOrgsAtom = atom<OrgsResponse>({
  key: 'orgadminOrgs',
  default: { status: 420, vctraceid: '', data: [] },
})
export const orgadminUsersAtom = atom<UsersResponse>({
  key: 'orgadminUsers',
  default: { status: 420, vctraceid: '', data: [] },
})

export const langDirection = selector<'LTR' | 'RTL'>({
  key: 'langDirection',
  get: ({ get }) => {
    const hubResponse = get(hubAtom)
    if (hubResponse?.data?.locale) {
      const currentLocale = hubResponse.data.locale
      return isRTL(currentLocale) ? 'RTL' : 'LTR'
    }
    return 'LTR'
  },
})

let currentAlertId = 0

export interface Alert {
  message: string
  type: string
  retry?: any // make this function(): void ? how?
}

export interface AlertWithId extends Alert {
  id: number
}

export const useAddAlert = () => {
  const setAlerts = useSetRecoilState<AlertWithId[]>(alertsAtom)

  return useRecoilCallback(
    ({ set }) => {
      return (alert: Alert) => {
        const newId = currentAlertId++
        setAlerts((oldAlerts) => [
          ...oldAlerts,
          {
            id: newId,
            ...alert,
          },
        ])
      }
    },
    [alertsAtom]
  )
}
